import { render } from "./EPortfolioMain.vue?vue&type=template&id=15155ae6&scoped=true"
import script from "./EPortfolioMain.vue?vue&type=script&lang=js"
export * from "./EPortfolioMain.vue?vue&type=script&lang=js"

import "./EPortfolioMain.vue?vue&type=style&index=0&id=15155ae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15155ae6"]])

export default __exports__